// action creators creators
export const STORE_INSPECTION = "STORE_INSPECTION";
export const REQUEST_INSPECTION = "REQUEST_INSPECTION";
export const GET_INSPECTION = "GET_INSPECTION";

export const STORE_VEHICLE = "STORE_VEHICLE";
export const REQUEST_VEHICLE = "REQUEST_VEHICLE";
export const GET_VEHICLE = "GET_VEHICLE";
export const ADD_VEHICLE = "ADD_VEHICLE";
export const UPDATE_VEHICLE = "UPDATE_VEHICLE";
export const STORE_VEHICLE_GRID = "STORE_VEHICLE_GRID";

export const STORE_USER = "STORE_USER";
export const STORE_CLIENT = "STORE_CLIENT";
export const STORE_PROFILE = "STORE_PROFILE";
export const UPDATE_PROFILE = "UPDATE_PROFILE";

export const STORE_EMP_PROFILE = "STORE_EMP_PROFILE";
export const UPDATE_EMP_PROFILE = "UPDATE_EMP_PROFILE";

export const ADD_TEAM_MEMBER = "ADD_TEAM_MEMBER";
export const STORE_TEAM = "STORE_TEAM";
export const UPDATE_TEAM = "UPDATE_TEAM";

export const STORE_USER_CHOICE = "STORE_USER_CHOICE";

export const STORE_ADMINCUSTOMERVEHICLES = "STORE_ADMINCUSTOMERVEHICLES";
export const USER_LOGOUT = "USER_LOGOUT";
export const STORE_CUSTFORMECH = "STORE_CUSTFORMECH";
// Action Creators
export const storeEmpProfile = data => {
  return {
    type: STORE_EMP_PROFILE,
    data: data
  };
};
export const updateEmpProfile = data => {
  return {
    type: UPDATE_EMP_PROFILE,
    data: data
  };
};
export const userLogout = data => {
  return {
    type: USER_LOGOUT,
    data: data
  };
};
export const storeInspection = data => {
  return {
    type: STORE_INSPECTION,
    data: data
  };
};
export const requestInspection = () => {
  return {
    type: REQUEST_INSPECTION,
    loading: true
  };
};
export const storeUserChoice = data => {
  return {
    type: STORE_USER_CHOICE,
    data: data
  };
};
export const storeVehicle = data => {
  return {
    type: STORE_VEHICLE,
    data: data
  };
};
export const storeVehicleGrid = data => {
  return {
    type: STORE_VEHICLE_GRID,
    data: data
  };
};
export const addVehicle = data => {
  return {
    type: ADD_VEHICLE,
    data: data
  };
};
export const updateVehicle = data => {
  return {
    type: UPDATE_VEHICLE,
    data: data
  };
};
export const requestVehicle = () => {
  return {
    type: REQUEST_VEHICLE,
    loading: true
  };
};

//config

export const storeClient = data => {
  return {
    type: STORE_CLIENT,
    data: data
  };
};
export const storeUser = data => {
  return {
    type: STORE_USER,
    data: data
  };
};
export const storeTeam = data => {
  return {
    type: STORE_TEAM,
    data: data
  };
};
export const addTeamMember = data => {
  return {
    type: ADD_TEAM_MEMBER,
    data: data
  };
};
export const updateTeam = data => {
  return {
    type: UPDATE_TEAM,
    data: data
  };
};
export const storeProfile = data => {
  return {
    type: STORE_PROFILE,
    data: data
  };
};
export const updateProfile = data => {
  return {
    type: UPDATE_PROFILE,
    data: data
  };
};
// STORE_ADMINCUSTOMERVEHICLES

export const storeAdminCustomerVehicles = data => {
  return {
    type: STORE_ADMINCUSTOMERVEHICLES,
    data: data
  };
};

export const customerForMechanic = data => {
  return {
    type: STORE_CUSTFORMECH,
    data
  };
}


// WEBPACK FOOTER //
// ./src/redux/actions/index.js